import React from 'react';
import Slider from 'react-slick';
import classnames from 'classnames';

const Arrow = ( {
  className, onClick, icon, onClickBtn, disabled,
} ) => (
  <i
    className={classnames( className, 'fas fa-4x', icon, {
      'slick-disabled': disabled,
    } )}
    onClick={() => {
      if ( onClick && !disabled ) {
        onClick();
        onClickBtn();
      }
    }}
  />
);

export default React.forwardRef( ( {
  children, nextDisabled = false, onPrev, onNext,
}, ref ) => (
  <Slider
    ref={ref}
    dots={false}
    infinite={false}
    draggable={false}
    slidesToShow={1}
    slidesToScroll={1}
    canGoNext={false}
    prevArrow={<Arrow icon="fa-chevron-circle-left" onClickBtn={onPrev} />}
    nextArrow={<Arrow icon="fa-chevron-circle-right" onClickBtn={onNext} disabled={nextDisabled} />}
  >
    {children}
  </Slider>
) );
